import {createSelector} from 'reselect'
import { State } from '../reducers/rootReducer'
import { E3DGrpAuthState } from '../reducers/e3DGrpAuthReducer'
import { getPersistedE3DGrpAuth } from '../persistLocalStorageE3DAuthState'

// Default state if nothing is available
const defaultState: E3DGrpAuthState = {
    user: null,
    shouldConnect: false,
    shouldConnectFromLoginComponent: false,
    loading: false,
    isLoggedIn: false,
    error: null,
}

// Base selector that combines Redux state with localStorage if needed
export const grpAuthStateSelector = (state: State): E3DGrpAuthState => {
    const reduxState = state.e3DGrpAuth as E3DGrpAuthState | undefined

    if (reduxState === undefined) {
        const persistedState = getPersistedE3DGrpAuth()
        return persistedState || defaultState
    }

    return reduxState
}

// Derived selectors
export const isGrpLoggedInSelector = createSelector(
    grpAuthStateSelector,
    (grpAuthState): boolean => !!grpAuthState?.user,
)

export const isGrpLoginLoadingSelector = createSelector(
    grpAuthStateSelector,
    (grpAuthState): boolean => {
        return grpAuthState?.loading
    },
)

export const grpLoginStatusSelector = createSelector(
    [isGrpLoggedInSelector, isGrpLoginLoadingSelector],
    (isLoggedIn, isLoading): 'none' | 'loading' | 'success' | 'error' => {
        if (isLoading) {
            return 'loading'
        }
        if (isLoggedIn) {
            return 'success'
        }
        return 'none'
    },
)
